// ConversionEventsTable.jsx
import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@material-ui/core";
import { URL as API_URL } from "../../config/config";
import axios from "axios";

const COLUMNS = [
    { key: "assistantId", label: "Assistant ID" },
    { key: "userNumber", label: "User Number" },
    { key: "adAccountId", label: "Ad Account ID" },
    { key: "event", label: "Event" },
    { key: "gclid", label: "GCLID" },
    { key: "conversionDateTime", label: "Conversion Time" },
    { key: "status", label: "Status" },
];

export default function ConversionEventsTable({ assistantId }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchConversionEvents = async () => {
            try {
                const response = await axios.get(`${API_URL}/superadmin/google-ads-conversion-events/assistants/${assistantId}`);
                setData(response.data.data);
            } catch (err) {
                console.error("Failed to fetch conversion events:", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        if (assistantId) fetchConversionEvents();
    }, [assistantId]);

    const exportCSV = () => {
        const header = COLUMNS.map((c) => c.label).join(",");
        const rows = data.map((row) =>
            COLUMNS.map((c) => {
                const val = row[c.key] ?? "";
                return String(val).includes(",") ? `"${val}"` : val;
            }).join(",")
        );
        const blob = new Blob([[header, ...rows].join("\n")], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `conversion-events-${assistantId}-${Date.now()}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    };

    if (loading) return <CircularProgress />;
    if (error) return <Typography color="error">Failed to load conversion events.</Typography>;

    return (
        <Box mt={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="h6"><b>Conversion Event Logs</b></Typography>
                <Button variant="outlined" color="primary" onClick={exportCSV} disabled={data.length === 0}>
                    ⬇ Export as CSV
                </Button>
            </Box>

            <Box style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, tableLayout: "fixed" }}>
                    <thead>
                        <tr style={{ background: "#f0f0f0" }}>
                            {COLUMNS.map((c) => (
                                <th
                                    key={c.key}
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        textAlign: "left",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {c.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 ? (
                            <tr>
                                <td colSpan={COLUMNS.length} style={{ textAlign: "center", padding: 16 }}>
                                    No records found.
                                </td>
                            </tr>
                        ) : (
                            data.map((row, i) => (
                                <tr key={i} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                                    {COLUMNS.map((c) => (
                                        <td
                                            key={c.key}
                                            title={row[c.key] ?? "—"}
                                            style={{
                                                border: "1px solid #ddd",
                                                padding: "8px",
                                                whiteSpace: "nowrap",
                                                maxWidth: "150px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {row[c.key] ?? "—"}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </Box>
        </Box>
    );
}